// extracted by mini-css-extract-plugin
module.exports = {"consoleButton":"ConsoleButton-module--consoleButton--_gzR_","link":"ConsoleButton-module--link--SQcbo"};